import api, { publicApi } from "./api";
import { todayLocal } from "../utils/dates";
import {
  AppointmentType, StaffBookingProfile, StaffAvailabilityRow, AvailabilityExceptionRow,
  CalendarBlock, Appointment, AppointmentCalendar, AppointmentPeople, AppointmentStatus,
  PublicStaff, BookingPage, BookingSlotDay, BookingRequest, GuestAppointment, GoogleAccountStatus,
  EdmAccountStatus, EdmAccountCredentials, EdmProbeResult,
  AppNotification, NotificationPreference, NotificationType, NotificationScanResult,
  ShippingStats, ShipmentStatus, ShipmentListItem, ShipmentDetail, ShipmentUpsert, ShipRequest, DeliverRequest, ShippableOrder, OrderShipmentSummary,
  Order,
  SendDocumentResult,
  SendDocumentLine,
  EDocumentListItem,
  EDocumentDetail,
  StandaloneDocumentRequest,
  IncomingInvoice,
  InboxHealth,
  InboxSyncResult,
  LedgerParty,
  ReceiptMatchCandidate,
  PostIncomingInvoiceRequest,
  PostIncomingInvoiceResult,
  ModelOverviewResponse,
  Model,
  Workshop,
  Operator,
  Technic,
  Firm,
  OrderImage,
  OrderTechnic,
  OrderStatus,
  ExchangeRate,
  Currency,
  User,
  Settings,
  InvoiceType,
  City,
  District,
  TaxOffice,
  CompanyProfile,
  ReceivablesOverview,
  FirmStatement,
  LedgerEntryUpsert,
  Supplier,
  SupplierUpsert,
  PurchasingStats,
  PurchaseOrderStatus,
  PurchaseOrderListItem,
  PurchaseOrderDetail,
  PurchaseOrderUpsert,
  ReceiveRequest,
  StockPriceHistory,
  SupplierRow, SupplierDetail,
  FinancialAccount, FinancialAccountUpsert, CashTransaction, CashTransactionUpsert, CashTransfer, CashOverview, CashList, CashQuery, UnlinkedCollection, OptionItem, CashTransactionSource,
  PayablesOverview, SupplierStatement, SupplierLedgerUpsert,
  Cheque, ChequeUpsert, ChequeAction, ChequeQuery, ChequeOverview,
  TrialBalance, CashFlow,
  HrSummary, HrNamedItem, HrPositionItem, Employee, EmployeeUpsert,
  LeaveType, LeaveTypeUpsert, PublicHoliday, LeaveBalance, LeavePreview, LeaveRequestRow, LeaveRequestCreate, LeaveStatus, EmployeeDocumentRow, DocumentCategory,
  AttendanceConfig, AttendanceSettingsRow, ShiftRow, DailyBoard, MonthSummaryRow, MyAttendance, PunchKind, PunchRow, DaySummaryRow, KioskIdentity, DeviceKind,
  HrMe, HrTeam, LeaveBalanceReport, EmployeeLoginResult, DocChecklist, DocCompliance, HrDocumentType, HrDocumentTypeUpsert,
  AuditDetail,
  AuditMeta,
  AuditPage,
  AuditQuery,
  AuditStats,
} from "../types";

// Cost service'ini import edelim
export { costService } from "./costService";

// Test servisi - authentication gerektirmez
export const testService = {
  testBackend: async () => {
    const response = await api.get("/Order/test");
    return response.data;
  },
};

// Invoice Type servisi
export const invoiceTypeService = {
  // Tüm fatura tiplerini getir
  getInvoiceTypes: async (): Promise<InvoiceType[]> => {
    const response = await api.get("/invoicetype");
    return response.data;
  },
};

// City servisi
export const cityService = {
  getCities: async (): Promise<City[]> => {
    const response = await api.get("/city");
    return response.data;
  },
  getCity: async (id: string): Promise<City> => {
    const response = await api.get(`/city/${id}`);
    return response.data;
  },
};

// District servisi
export const districtService = {
  getDistricts: async (): Promise<District[]> => {
    const response = await api.get("/district");
    return response.data;
  },
  getDistrictsByCity: async (cityId: string): Promise<District[]> => {
    const response = await api.get(`/district/city/${cityId}`);
    return response.data;
  },
  getDistrict: async (id: string): Promise<District> => {
    const response = await api.get(`/district/${id}`);
    return response.data;
  },
};

// TaxOffice servisi
export const taxOfficeService = {
  getTaxOffices: async (): Promise<TaxOffice[]> => {
    const response = await api.get("/taxoffice");
    return response.data;
  },
  getTaxOfficesByCity: async (cityId: string): Promise<TaxOffice[]> => {
    const response = await api.get(`/taxoffice/city/${cityId}`);
    return response.data;
  },
  getTaxOffice: async (id: string): Promise<TaxOffice> => {
    const response = await api.get(`/taxoffice/${id}`);
    return response.data;
  },
};

// Firm servisleri ekleyin
export const firmService = {
  // Tüm firmaları getir
  getFirms: async (): Promise<Firm[]> => {
    const response = await api.get("/firm");
    return response.data;
  },

  // ID ile firma getir
  getFirm: async (id: string): Promise<Firm> => {
    const response = await api.get(`/firm/${id}`);
    return response.data;
  },

  // Firma kodu ile firma getir
  getFirmByCode: async (firmCode: string): Promise<Firm> => {
    const response = await api.get(`/firm/code/${firmCode}`);
    return response.data;
  },

  // Yeni firma oluştur
  createFirm: async (
    firm: Omit<Firm, "firmId" | "createdAt" | "createdBy" | "isActive">,
  ): Promise<Firm> => {
    const response = await api.post("/firm", firm);
    return response.data;
  },

  // Firma güncelle
  updateFirm: async (id: string, firm: Partial<Firm>): Promise<Firm> => {
    const response = await api.put(`/firm/${id}`, firm);
    return response.data;
  },

  // Firma sil
  deleteFirm: async (id: string): Promise<void> => {
    await api.delete(`/firm/${id}`);
  },

  // Firma siparişlerini getir
  getFirmOrders: async (firmId: string): Promise<Order[]> => {
    const response = await api.get(`/firm/${firmId}/orders`);
    return response.data;
  },
};

// Utility: Backend'den gelen sayısal status'u enum'a çevir
const normalizeOrderStatus = (status: any): OrderStatus => {
  // Eğer undefined veya null ise varsayılan değer döndür
  if (status === undefined || status === null) {
    return OrderStatus.Atanmadi;
  }

  // Sayısal değeri enum'a çevir
  const statusMap: { [key: number]: OrderStatus } = {
    1: OrderStatus.Atanmadi,
    2: OrderStatus.Islemde,
    3: OrderStatus.IptalEdildi,
    4: OrderStatus.Tamamlandi,
  };

  return statusMap[status] || OrderStatus.Atanmadi;
};

// Utility: Frontend'deki string enum'u backend için sayısal değere çevir
const denormalizeOrderStatus = (status: OrderStatus): number => {
  const statusMap: { [key in OrderStatus]: number } = {
    [OrderStatus.Atanmadi]: 1,
    [OrderStatus.Islemde]: 2,
    [OrderStatus.IptalEdildi]: 3,
    [OrderStatus.Tamamlandi]: 4,
  };

  return statusMap[status];
};

// Order objelerindeki status'u normalize et (backend -> frontend)
const normalizeOrder = (order: any): Order => {
  // Backend'den flat yapıda gelen veriyi nested yapıya çevir
  const normalized: Order = {
    orderId: order.orderId,
    acceptanceDate: order.acceptanceDate,
    modelistUserId: order.modelistUserId,
    completionDate: order.completionDate,
    deadline: order.deadline,
    firmId: order.firmId,
    firm:
      order.firm ||
      (order.firmName
        ? {
            firmId: order.firmId,
            firmName: order.firmName,
            firmCode: order.firmCode || "",
            contactPerson: order.firmContactPerson || "",
            phone: order.firmPhone || "",
            email: order.firmEmail || "",
            address: order.firmAddress || "",
            taxNumber: order.firmTaxNumber || "",
            taxOffice: order.firmTaxOffice || "",
            description: order.firmDescription || "",
            createdAt: order.firmCreatedAt || "",
            createdBy: order.firmCreatedBy || "",
            updatedAt: order.firmUpdatedAt,
            updatedBy: order.firmUpdatedBy,
            isActive:
              order.firmIsActive !== undefined ? order.firmIsActive : true,
          }
        : undefined),
    modelId: order.modelId,
    model:
      order.model ||
      (order.modelName
        ? {
            modelId: order.modelId,
            modelName: order.modelName,
            modelCode: order.modelCode || "",
            description: order.modelDescription || "",
            season: order.modelSeason || "",
            category: order.modelCategory || "",
            color: order.modelColor || "",
            size: order.modelSize || "",
            fabric: order.modelFabric || "",
            imageUrl: order.modelImageUrl || "",
            estimatedPrice: order.modelEstimatedPrice,
            estimatedProductionTime: order.modelEstimatedProductionTime,
          }
        : undefined),
    quantity: order.quantity,
    unit: order.orderUnitId !== undefined ? order.orderUnitId : undefined,
    pieceCount: order.pieceCount,
    // En/Boy taşınmazsa düzenleme ekranları bunları geri gönderemez ve
    // PUT körleme kopyaladığı için her kayıtta siliniyorlar.
    width: order.width,
    height: order.height,
    price: order.price,
    priceCurrency: order.priceCurrency || order.currency,
    currency: order.priceCurrency || order.currency, // Geriye dönük uyumluluk
    vatRate: order.vatRate,
    invoiceTypeId: order.invoiceTypeId,
    invoiceTypeName: order.invoiceTypeName,
    workshopId: order.workshopId,
    workshop:
      order.workshop ||
      (order.workshopName
        ? {
            workshopId: order.workshopId,
            name: order.workshopName,
            description: order.workshopDescription || "",
            location: order.workshopLocation || "",
            contactPerson: order.workshopContactPerson || "",
            phone: order.workshopPhone || "",
          }
        : undefined),
    operatorId: order.operatorId,
    operator:
      order.operator ||
      (order.operatorName
        ? {
            operatorId: order.operatorId,
            firstName:
              order.operatorFirstName ||
              order.operatorName.split(" ")[0] ||
              order.operatorName,
            lastName:
              order.operatorLastName ||
              order.operatorName.split(" ").slice(1).join(" ") ||
              "",
            phone: order.operatorPhone || "",
            email: order.operatorEmail || "",
            specialization: order.operatorSpecialization || "",
            workshopId: order.workshopId,
            workshop: order.workshop,
          }
        : undefined),
    modelistUser:
      order.modelistUser ||
      (order.modelistUserName
        ? {
            userId: order.modelistUserId || "",
            firstName:
              order.modelistUserName.split(" ")[0] || order.modelistUserName,
            lastName:
              order.modelistUserName.split(" ").slice(1).join(" ") || "",
            email: "",
            role: "Modelist",
            workshopId: undefined,
            workshop: undefined,
          }
        : undefined),
    priority: order.priority,
    note: order.note,
    invoice: order.invoice,
    invoiceNumber: order.invoiceNumber,
    isSample: order.isSample || order.IsSample || false, // Backend'den gelen numune bilgisi
    status:
      order.orderStatusId !== undefined
        ? normalizeOrderStatus(order.orderStatusId)
        : order.status !== undefined
          ? normalizeOrderStatus(order.status)
          : OrderStatus.Atanmadi,
    qrCodeUrl: order.qrCodeUrl,
    qrCode: order.qrCodeUrl, // Geriye dönük uyumluluk
    images:
      order.images ||
      (order.imageUrls
        ? order.imageUrls.map((url: string, index: number) => ({
            orderImageId: `${order.orderId}-${index}`,
            orderId: order.orderId,
            imageUrl: url,
            description: "",
            displayOrder: index,
          }))
        : []),
    orderTechnics:
      order.orderTechnics ||
      (order.technicNames
        ? order.technicNames.map((name: string, index: number) => ({
            orderTechnicId: `${order.orderId}-technic-${index}`,
            orderId: order.orderId,
            technicId: "",
            technic: {
              technicId: "",
              name: name,
              description: "",
              category: "",
            },
          }))
        : []),
    createdAt: order.createdAt || new Date().toISOString(),
    createdBy: order.createdBy || "",
    updatedAt: order.updatedAt,
    updatedBy: order.updatedBy,
    isActive:
      order.isActive !== undefined
        ? order.isActive
        : order.IsActive !== undefined
          ? order.IsActive
          : true,
    workshopDuration: order.workshopDuration, // Backend'den gelen atölyede geçen süre
  };

  return normalized;
};

// Order objelerindeki status'u denormalize et (frontend -> backend)
const denormalizeOrder = (order: Order): any => {
  const { status, ...rest } = order;
  return {
    ...rest,
    orderStatusId:
      status !== undefined && status !== null
        ? denormalizeOrderStatus(status)
        : 1, // Default: Atanmadi = 1
  };
};

export const orderService = {
  getAll: async (): Promise<Order[]> => {
    const response = await api.get<Order[]>("/Order");
    return response.data.map(normalizeOrder);
  },
  getAllOrders: async (): Promise<Order[]> => {
    const response = await api.get<Order[]>("/order/allorders");
    return response.data.map(normalizeOrder);
  },

  // Kanban için optimize edilmiş endpoint - WorkshopDuration dahil
  getActiveOrdersForKanban: async (): Promise<Order[]> => {
    const response = await api.get<Order[]>("/Kanban/active-orders");
    return response.data.map(normalizeOrder);
  },

  getPassiveOrders: async (): Promise<Order[]> => {
    const response = await api.get<Order[]>("/Order/passiveorders");
    return response.data.map(normalizeOrder);
  },

  getInvoiced: async (): Promise<Order[]> => {
    const response = await api.get<Order[]>("/Order/invoiced");
    return response.data.map(normalizeOrder);
  },

  getById: async (id: string): Promise<Order> => {
    const response = await api.get<Order>(`/Order/${id}`);
    return normalizeOrder(response.data);
  },

  create: async (
    order: Omit<Order, "orderId" | "createdAt" | "updatedAt">,
  ): Promise<Order> => {
    // Status'u numeric'e çevir ve gönder
    const backendOrder = {
      ...order,
      orderStatusId: order.status ? denormalizeOrderStatus(order.status) : 0,
    };
    // status alanını gönderme
    delete backendOrder.status;
    const response = await api.post<any>("/Order", backendOrder);
    // Response'u normalize et
    return normalizeOrder(response.data);
  },

  update: async (id: string, order: Order): Promise<void> => {
    // Status'u numeric'e çevir ve gönder
    const backendOrder = denormalizeOrder(order);
    await api.put(`/Order/${id}`, backendOrder);
  },

  // Elle fatura bilgisi — YALNIZ fatura modülü lisansta yokken (aksi halde 403 MODULE_ENABLED)
  updateInvoice: async (
    id: string,
    data: { invoice: string | null; invoiceNumber: string | null },
  ): Promise<void> => {
    await api.put(`/Order/${id}/invoice`, data);
  },

  // E-belge kes: firmanın fatura tipine göre EDM (e-Fatura/e-Arşiv) veya
  // Faturasız (proforma) servisine gönderir. Tutar GÖNDERİLMEZ — miktar ve
  // birim fiyat sunucudan gider, hesap servislerin kuruş aritmetiğinde yapılır.
  sendDocument: async (
    id: string,
    data: { lines: SendDocumentLine[]; note?: string },
  ): Promise<SendDocumentResult> => {
    const response = await api.post(`/Order/${id}/send-document`, data);
    return response.data;
  },

  // Yeni atama endpointi (workshop/operator/status)
  assign: async (
    id: string,
    data: {
      workshopId?: string | null;
      operatorId?: string | null;
      orderStatusId?: number | null;
    },
  ): Promise<void> => {
    await api.put(`/Order/${id}/assign`, data);
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/Order/${id}`);
  },

  // Yeni file upload endpoint'i
  uploadImages: async (
    orderId: string,
    files: File[],
  ): Promise<{ message: string; images: any[] }> => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("files", file);
    });

    const response = await api.post(
      `/Order/${orderId}/upload-images`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  },

  // Sipariş resimlerini getir
  getImages: async (orderId: string): Promise<OrderImage[]> => {
    const response = await api.get<OrderImage[]>(`/Order/${orderId}/images`);
    return response.data;
  },

  // Resim sil - yeni endpoint yapısı
  deleteImage: async (imageId: string): Promise<void> => {
    await api.delete(`/Order/image/${imageId}`);
  },

  // Eski addImage metodu - backward compatibility için kalsın
  addImage: async (
    orderId: string,
    image: Omit<
      OrderImage,
      "orderImageId" | "orderId" | "createdAt" | "createdBy"
    >,
  ): Promise<OrderImage> => {
    const response = await api.post<OrderImage>(
      `/Order/${orderId}/images`,
      image,
    );
    return response.data;
  },

  // Order log'larını getir
  getOrderLogs: async (orderId: string): Promise<any[]> => {
    const response = await api.get(`/Order/${orderId}/logs`);
    return response.data;
  },

  // Son N değişikliği getir (tüm order'lar)
  getRecentLogs: async (count: number = 50): Promise<any[]> => {
    const response = await api.get(`/Order/logs/recent?count=${count}`);
    return response.data;
  },

  addTechnic: async (
    orderId: string,
    technicId: string,
  ): Promise<OrderTechnic> => {
    const response = await api.post<OrderTechnic>(
      `/Order/${orderId}/technics`,
      { technicId },
    );
    return response.data;
  },

  deleteTechnic: async (orderId: string, technicId: string): Promise<void> => {
    await api.delete(`/Order/${orderId}/technics/${technicId}`);
  },

  // Yeni API endpoint'leri
  // Status filtreli sipariş getirme
  getAllByStatus: async (status?: OrderStatus): Promise<Order[]> => {
    // Backend numeric enum bekliyor, string enum'u sayıya çevir
    let statusParam = "";
    if (status) {
      const statusMap: { [key in OrderStatus]: number } = {
        [OrderStatus.Atanmadi]: 1,
        [OrderStatus.Islemde]: 2,
        [OrderStatus.IptalEdildi]: 3,
        [OrderStatus.Tamamlandi]: 4,
      };
      statusParam = statusMap[status].toString();
    }

    const url = statusParam ? `/Order?status=${statusParam}` : "/Order";
    const response = await api.get<Order[]>(url);
    return response.data.map(normalizeOrder);
  },

  // Sipariş status'ını güncelle
  updateStatus: async (
    orderId: string,
    status: OrderStatus,
  ): Promise<{
    message: string;
    orderId: string;
    newStatus: string;
    completionDate?: string;
  }> => {
    // String enum'u sayısal değere çevir (backend numeric enum bekliyor)
    const statusMap: { [key in OrderStatus]: number } = {
      [OrderStatus.Atanmadi]: 1,
      [OrderStatus.Islemde]: 2,
      [OrderStatus.IptalEdildi]: 3,
      [OrderStatus.Tamamlandi]: 4,
    };

    const numericStatus = statusMap[status];

    // Log if status is Tamamlandı (backend will handle completionDate automatically)
    if (status === OrderStatus.Tamamlandi) {
    }

    try {
      // Backend endpoint: PUT /Order/{id}/status beklenen body: [FromBody] OrderStatus status
      // Sadece sayısal enum değerini gönder (primitive value olarak)
      const response = await api.put(
        `/Order/${orderId}/status`,
        numericStatus,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      return response.data;
    } catch (error: any) {
      console.error("❌ Status update failed:", error.response?.status);
      console.error("❌ Error details:", error.response?.data);
      throw error;
    }
  },

  // Status'a göre siparişleri getir
  getByStatus: async (status: OrderStatus): Promise<any[]> => {
    const response = await api.get(`/Order/by-status/${status}`);
    return response.data.map(normalizeOrder);
  },

  // Status özeti
  getStatusSummary: async (): Promise<
    { Status: string; Count: number; TotalValue: number }[]
  > => {
    const response = await api.get("/Order/status-summary");
    return response.data;
  },

  // Numune durumunu güncelle
  updateSampleStatus: async (
    orderId: string,
    isSample: boolean,
  ): Promise<void> => {
    await api.patch(`/Order/${orderId}/sample`, { isSample });
  },
};

export const modelService = {
  getAll: async (): Promise<Model[]> => {
    const response = await api.get<Model[]>("/Model");
    return response.data;
  },

  getById: async (id: string): Promise<Model> => {
    const response = await api.get<Model>(`/Model/${id}`);
    return response.data;
  },

  getPriceHistory: async (id: string) => {
    const response = await api.get(`/Model/${id}/prices`);
    return response.data;
  },

  // Katalog özeti: tek istekte görseller, sipariş sayıları ve son maliyet seti
  overview: async (): Promise<ModelOverviewResponse> => {
    const response = await api.get<ModelOverviewResponse>("/Model/overview");
    return response.data;
  },

  create: async (model: Omit<Model, "modelId">): Promise<Model> => {
    const response = await api.post<Model>("/Model", model);
    return response.data;
  },

  update: async (id: string, model: Model): Promise<void> => {
    await api.put(`/Model/${id}`, model);
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/Model/${id}`);
  },
};

export const workshopService = {
  getAll: async (): Promise<Workshop[]> => {
    const response = await api.get<Workshop[]>("/Workshop");
    return response.data;
  },

  getConnections: async (workshopId: string): Promise<any[]> => {
    const response = await api.get(`/Workshop/${workshopId}/connections`);
    return response.data;
  },

  addConnection: async (
    workshopId: string,
    data: { targetWorkshopId: string; notes?: string },
  ): Promise<any> => {
    const response = await api.post(
      `/Workshop/${workshopId}/connections`,
      data,
    );
    return response.data;
  },

  removeConnection: async (
    workshopId: string,
    connectionId: string,
  ): Promise<void> => {
    await api.delete(`/Workshop/${workshopId}/connections/${connectionId}`);
  },

  create: async (workshop: Omit<Workshop, "workshopId">): Promise<Workshop> => {
    const response = await api.post<Workshop>("/Workshop", workshop);
    return response.data;
  },

  update: async (
    id: string,
    workshop: Partial<Workshop>,
  ): Promise<Workshop> => {
    const response = await api.put<Workshop>(`/Workshop/${id}`, workshop);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/Workshop/${id}`);
  },
};

export const operatorService = {
  getAll: async (): Promise<Operator[]> => {
    const response = await api.get<Operator[]>("/Operator");
    return response.data;
  },

  create: async (operator: Omit<Operator, "operatorId">): Promise<Operator> => {
    const response = await api.post<Operator>("/Operator", operator);
    return response.data;
  },
};

export const technicService = {
  getAll: async (): Promise<Technic[]> => {
    const response = await api.get<Technic[]>("/Technic");
    return response.data;
  },

  create: async (technic: Omit<Technic, "technicId">): Promise<Technic> => {
    const response = await api.post<Technic>("/Technic", technic);
    return response.data;
  },

  update: async (
    technicId: string,
    technic: Partial<Omit<Technic, "technicId">>,
  ): Promise<Technic> => {
    const response = await api.put<Technic>(`/Technic/${technicId}`, {
      ...technic,
      technicId, // Backend body'de technicId bekliyor
    });
    return response.data;
  },

  delete: async (technicId: string): Promise<void> => {
    await api.delete(`/Technic/${technicId}`);
  },
};

export const exchangeRateService = {
  // En güncel kur bilgilerini getir
  getLatest: async (): Promise<ExchangeRate[]> => {
    const response = await api.get<ExchangeRate[]>("/ExchangeRate/latest");
    return response.data;
  },

  // Belirli bir para birimi için kur bilgisi
  getByCurrency: async (currencyCode: string): Promise<ExchangeRate> => {
    const response = await api.get<ExchangeRate>(
      `/ExchangeRate/latest/${currencyCode}`,
    );
    return response.data;
  },

  // Desteklenen para birimlerini getir
  getCurrencies: async (): Promise<Currency[]> => {
    const response = await api.get<Currency[]>("/ExchangeRate/currencies");
    return response.data;
  },
};

// User servisi - Modelist yönetimi
export const userService = {
  // Tüm kullanıcıları getir
  getAll: async (): Promise<User[]> => {
    const response = await api.get<User[]>("/User");
    return response.data;
  },

  // Yeni geçici şifre üret ve gönder (İK modülü yokken Kullanıcı Yönetimi'nden)
  resetLogin: async (id: string): Promise<EmployeeLoginResult> =>
    (await api.post(`/User/${id}/reset-password`)).data,

  // Aktif modelistleri getir
  getModelists: async (): Promise<User[]> => {
    const response = await api.get<User[]>("/User/modelists");
    return response.data;
  },

  // Kullanıcı güncelle
  update: async (
    id: string,
    userData: {
      email?: string;
      firstName?: string;
      lastName?: string;
      role?: string;
      workshopId?: string | null;
      isActive?: boolean;
      password?: string;
    },
  ): Promise<User> => {
    const response = await api.put<User>(`/User/${id}`, userData);
    return response.data;
  },

  // Kullanıcı sil
  delete: async (id: string): Promise<void> => {
    await api.delete(`/User/${id}`);
  },
};

// Modelist Order servisi - Modeliste atanan siparişler
export const modelistOrderService = {
  // Giriş yapan modeliste atanmış tüm siparişleri listeler
  getMyOrders: async (status?: OrderStatus): Promise<Order[]> => {
    const params = status !== undefined ? { status } : {};
    const response = await api.get<Order[]>("/ModelistOrder", { params });
    return response.data.map(normalizeOrder);
  },

  // Belirli bir sipariş detayını getirir (sadece kendi siparişi ise)
  getOrderById: async (id: string): Promise<Order> => {
    const response = await api.get<Order>(`/ModelistOrder/${id}`);
    return normalizeOrder(response.data);
  },

  // Modelist için istatistikler
  getStats: async (): Promise<{
    total: number;
    pending: number;
    completed: number;
    unassigned: number;
  }> => {
    const response = await api.get("/ModelistOrder/stats");
    return response.data;
  },

  // Sipariş durumunu güncelle
  updateStatus: async (orderId: string, status: OrderStatus): Promise<void> => {
    await api.put(`/Order/${orderId}/assign`, {
      orderStatusId: status,
    });
  },
};

// Settings servisi
export const settingsService = {
  getAll: async (): Promise<Settings[]> => {
    const response = await api.get<Settings[]>("/Settings");
    return response.data;
  },

  getById: async (id: string): Promise<Settings> => {
    const response = await api.get<Settings>(`/Settings/${id}`);
    return response.data;
  },

  getDefault: async (): Promise<Settings> => {
    const response = await api.get<Settings>("/Settings/default");
    return response.data;
  },

  create: async (
    settings: Omit<
      Settings,
      "settingsId" | "createdAt" | "createdBy" | "isActive"
    >,
  ): Promise<Settings> => {
    const response = await api.post<Settings>("/Settings", settings);
    return response.data;
  },

  update: async (id: string, settings: Partial<Settings>): Promise<void> => {
    await api.put(`/Settings/${id}`, settings);
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/Settings/${id}`);
  },
};

// Report servisi
export const reportService = {
  getOrdersWithCosts: async (
    pageNumber: number = 1,
    pageSize: number = 50,
    firmId?: string,
    modelId?: string,
    startDate?: string,
    endDate?: string,
  ): Promise<any> => {
    const response = await api.get("/Report/orders-with-costs", {
      params: {
        pageNumber,
        pageSize,
        firmId: firmId !== "all" ? firmId : undefined,
        modelId: modelId !== "all" ? modelId : undefined,
        startDate,
        endDate,
      },
    });
    return response.data;
  },
  getSummary: async (
    firmId?: string,
    modelId?: string,
    startDate?: string,
    endDate?: string,
  ): Promise<any> => {
    const response = await api.get("/Report/summary", {
      params: {
        firmId: firmId !== "all" ? firmId : undefined,
        modelId: modelId !== "all" ? modelId : undefined,
        startDate,
        endDate,
      },
    });
    return response.data;
  },
  getMonthlyQuantity: async (year?: number, firmId?: string): Promise<any[]> => {
    const response = await api.get("/Report/monthly-quantity", {
      params: { year, firmId: firmId && firmId !== "all" ? firmId : undefined },
    });
    return response.data;
  },
  getMonthlyRevenue: async (year?: number, firmId?: string): Promise<any[]> => {
    const response = await api.get("/Report/monthly-revenue", {
      params: { year, firmId: firmId && firmId !== "all" ? firmId : undefined },
    });
    return response.data;
  },
  getCustomerRevenue: async (startDate?: string, endDate?: string): Promise<any[]> => {
    const response = await api.get("/Report/customer-revenue", {
      params: { startDate, endDate },
    });
    return response.data;
  },
  getMonthlyProfit: async (year?: number, firmId?: string): Promise<any[]> => {
    const response = await api.get("/Report/monthly-profit", {
      params: { year, firmId: firmId && firmId !== "all" ? firmId : undefined },
    });
    return response.data;
  },
};

export const dynamicReportService = {
  getDataSources: async (): Promise<any[]> => {
    const response = await api.get("/DynamicReport/datasources");
    return response.data;
  },
  getColumns: async (dataSourceName: string): Promise<any> => {
    const response = await api.get(`/DynamicReport/datasources/${encodeURIComponent(dataSourceName)}/columns`);
    return response.data;
  },
  getFieldValues: async (dataSourceName: string, field: string): Promise<string[]> => {
    const response = await api.get(
      `/DynamicReport/datasources/${encodeURIComponent(dataSourceName)}/fields/${encodeURIComponent(field)}/values`,
    );
    return response.data;
  },
  execute: async (request: any): Promise<any> => {
    const response = await api.post("/DynamicReport/execute", request);
    return response.data;
  },
  exportExcel: async (request: any): Promise<Blob> => {
    const response = await api.post("/DynamicReport/export/excel", request, {
      responseType: "blob",
    });
    return response.data;
  },

  // ── Birleşik pivot (kaynak seçimsiz) ──
  getPivotFields: async (): Promise<any[]> => {
    const response = await api.get("/DynamicReport/pivot/fields");
    return response.data;
  },
  getPivotFieldValues: async (field: string): Promise<string[]> => {
    const response = await api.get(
      `/DynamicReport/pivot/fields/${encodeURIComponent(field)}/values`,
    );
    return response.data;
  },
  executePivot: async (request: any): Promise<any> => {
    const response = await api.post("/DynamicReport/pivot", request);
    return response.data;
  },
  exportPivotExcel: async (request: any): Promise<Blob> => {
    const response = await api.post("/DynamicReport/pivot/export/excel", request, {
      responseType: "blob",
    });
    return response.data;
  },
};

export const reportTemplateService = {
  getAll: async (): Promise<any[]> => {
    const response = await api.get("/ReportTemplate");
    return response.data;
  },
  getById: async (id: string): Promise<any> => {
    const response = await api.get(`/ReportTemplate/${id}`);
    return response.data;
  },
  create: async (data: any): Promise<any> => {
    const response = await api.post("/ReportTemplate", data);
    return response.data;
  },
  update: async (id: string, data: any): Promise<any> => {
    const response = await api.put(`/ReportTemplate/${id}`, data);
    return response.data;
  },
  delete: async (id: string): Promise<void> => {
    await api.delete(`/ReportTemplate/${id}`);
  },
  execute: async (id: string, pageNumber: number = 1, pageSize: number = 50): Promise<any> => {
    const response = await api.post(`/ReportTemplate/${id}/execute`, null, {
      params: { pageNumber, pageSize },
    });
    return response.data;
  },
  exportExcel: async (id: string): Promise<Blob> => {
    const response = await api.post(`/ReportTemplate/${id}/export/excel`, null, {
      responseType: "blob",
    });
    return response.data;
  },
};

// Kesilen belgeler — liste yerel kayıttan, canlı durum/çıktılar proxy ile
export const eDocumentService = {
  list: async (filters?: {
    firmId?: string;
    serviceKind?: string;
    success?: boolean;
    from?: string;
    to?: string;
    search?: string;
  }): Promise<EDocumentListItem[]> => {
    const params = new URLSearchParams();
    if (filters?.firmId) params.set("firmId", filters.firmId);
    if (filters?.serviceKind) params.set("serviceKind", filters.serviceKind);
    if (filters?.success !== undefined)
      params.set("success", String(filters.success));
    if (filters?.from) params.set("from", filters.from);
    if (filters?.to) params.set("to", filters.to);
    if (filters?.search) params.set("search", filters.search);
    const response = await api.get(`/EDocuments?${params.toString()}`);
    return response.data;
  },

  detail: async (orderInvoiceId: string): Promise<EDocumentDetail> => {
    const response = await api.get(`/EDocuments/${orderInvoiceId}`);
    return response.data;
  },

  refresh: async (orderInvoiceId: string) => {
    const response = await api.post(`/EDocuments/${orderInvoiceId}/refresh`);
    return response.data;
  },

  // HTML/PDF proxy JWT ister; <a href> token taşıyamaz, blob ile iniyor.
  openRender: async (orderInvoiceId: string, format: "html" | "pdf" | "xml") => {
    const response = await api.get(
      `/EDocuments/${orderInvoiceId}/render/${format}`,
      { responseType: "blob" },
    );
    const url = URL.createObjectURL(response.data);
    window.open(url, "_blank");
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  },

  // Sipariş dışı (serbest) belge: alıcı ve para birimi istekte. Aynı requestId ile
  // yeniden deneme aynı belgeye ulaşır; yeni fatura için yeni taslak açılır.
  sendStandalone: async (data: StandaloneDocumentRequest): Promise<SendDocumentResult> => {
    const response = await api.post("/EDocuments/standalone", data);
    return response.data;
  },
};

// Gelen faturalar — platformun gelen kutusu; liste, çıktı ve kabul/red backend üzerinden proxy'lenir
export const incomingInvoiceService = {
  list: async (filters?: { from?: string; to?: string }): Promise<IncomingInvoice[]> =>
    (await api.get<IncomingInvoice[]>("/IncomingInvoices", { params: filters })).data,
  detail: async (uuid: string): Promise<IncomingInvoice> =>
    (await api.get<IncomingInvoice>(`/IncomingInvoices/${uuid}`)).data,
  sync: async (): Promise<InboxSyncResult> => (await api.post<InboxSyncResult>("/IncomingInvoices/sync")).data,
  health: async (): Promise<InboxHealth> => (await api.get<InboxHealth>("/IncomingInvoices/health")).data,
  history: async (uuid: string): Promise<any> => (await api.get(`/IncomingInvoices/${uuid}/history`)).data,
  markRead: async (uuid: string): Promise<void> => { await api.post(`/IncomingInvoices/${uuid}/mark-read`); },
  respond: async (uuid: string, accept: boolean, reason?: string): Promise<void> => {
    await api.post(`/IncomingInvoices/${uuid}/respond`, { accept, reason });
  },
  post: async (uuid: string, body: PostIncomingInvoiceRequest): Promise<PostIncomingInvoiceResult> =>
    (await api.post<PostIncomingInvoiceResult>(`/IncomingInvoices/${uuid}/post`, body)).data,
  parties: async (): Promise<{ suppliers: LedgerParty[]; firms: LedgerParty[] }> =>
    (await api.get("/IncomingInvoices/parties")).data,
  receiptCandidates: async (supplierId: string): Promise<ReceiptMatchCandidate[]> =>
    (await api.get<ReceiptMatchCandidate[]>("/IncomingInvoices/receipt-candidates", { params: { supplierId } })).data,

  // Çıktı JWT ister; blob olarak iner. HTML sekmede açılır, PDF/XML indirilir.
  openRender: async (uuid: string, format: "html" | "pdf" | "xml", fileName?: string) => {
    const response = await api.get(`/IncomingInvoices/${uuid}/render/${format}`, { responseType: "blob" });
    const url = URL.createObjectURL(response.data);
    if (format === "html") {
      window.open(url, "_blank");
    } else {
      const a = document.createElement("a");
      a.href = url;
      a.download = `${fileName || uuid}.${format}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  },
};

// Kesilen belge üzerinde işlemler — hepsi Textile backend'i üzerinden proxy'lenir
export const eDocumentActions = {
  history: async (id: string) => {
    const response = await api.get(`/EDocuments/${id}/history`);
    return response.data;
  },

  sendEmail: async (id: string, emails: string[], note?: string) => {
    const response = await api.post(`/EDocuments/${id}/email`, { emails, note });
    return response.data;
  },

  resend: async (id: string) => {
    const response = await api.post(`/EDocuments/${id}/resend`);
    return response.data;
  },

  cancel: async (id: string, reason: string) => {
    const response = await api.post(`/EDocuments/${id}/cancel`, { reason });
    return response.data;
  },

  objection: async (
    id: string,
    data: {
      documentNo: string;
      documentDate: string;
      method: string;
      description: string;
    },
  ) => {
    const response = await api.post(`/EDocuments/${id}/objection`, data);
    return response.data;
  },

  changeState: async (id: string, state: string) => {
    const response = await api.post(`/EDocuments/${id}/state`, { state });
    return response.data;
  },
};

// Şirket profili — fatura başlığındaki satıcı bloğu. settings:view ister; yetki
// yoksa/tanımsızsa null döner, belge kesimi yine sunucuda doğrulanır.
export const companyProfileService = {
  get: async (): Promise<CompanyProfile | null> => {
    try {
      const response = await api.get<CompanyProfile>("/CompanyProfile");
      return response.data;
    } catch {
      return null;
    }
  },
  /** Tek kaydı oluşturur ya da günceller (settings:update) */
  save: async (dto: Partial<CompanyProfile>): Promise<CompanyProfile> => (await api.put<CompanyProfile>("/CompanyProfile", dto)).data,

  // Entegratör hesabı — kimlik bilgileri Nedaris'te SAKLANMAZ, platforma iletilir
  edmAccount: async (): Promise<EdmAccountStatus> =>
    (await api.get<EdmAccountStatus>("/CompanyProfile/edm-account")).data,
  probeEdmAccount: async (dto: EdmAccountCredentials): Promise<EdmProbeResult> =>
    (await api.post<EdmProbeResult>("/CompanyProfile/edm-account/probe", dto)).data,
  saveEdmAccount: async (dto: EdmAccountCredentials): Promise<EdmAccountStatus> =>
    (await api.put<EdmAccountStatus>("/CompanyProfile/edm-account", dto)).data,
};

// Kasa ve Banka — finans modülü (finance); modül yoksa 403 MODULE_DISABLED
export const cashService = {
  overview: async (): Promise<CashOverview> => (await api.get<CashOverview>("/Cash/overview")).data,
  accounts: async (includeInactive = false): Promise<FinancialAccount[]> => (await api.get<FinancialAccount[]>("/Cash/accounts", { params: { includeInactive } })).data,
  createAccount: async (dto: FinancialAccountUpsert): Promise<{ financialAccountId: string }> => (await api.post("/Cash/accounts", dto)).data,
  updateAccount: async (id: string, dto: FinancialAccountUpsert): Promise<void> => { await api.put(`/Cash/accounts/${id}`, dto); },
  removeAccount: async (id: string): Promise<{ deleted: boolean; message: string }> => (await api.delete(`/Cash/accounts/${id}`)).data,
  transactions: async (q: CashQuery): Promise<CashList> => (await api.get<CashList>("/Cash/transactions", { params: q })).data,
  create: async (dto: CashTransactionUpsert): Promise<{ cashTransactionId: string; firmLedgerEntryId?: string | null }> => (await api.post("/Cash/transactions", dto)).data,
  update: async (id: string, dto: CashTransactionUpsert): Promise<void> => { await api.put(`/Cash/transactions/${id}`, dto); },
  remove: async (id: string): Promise<void> => { await api.delete(`/Cash/transactions/${id}`); },
  transfer: async (dto: CashTransfer): Promise<{ transferGroupId: string }> => (await api.post("/Cash/transfer", dto)).data,
  unlinked: async (): Promise<UnlinkedCollection[]> => (await api.get<UnlinkedCollection[]>("/Cash/unlinked-collections")).data,
  link: async (financialAccountId: string, firmLedgerEntryIds: string[], supplierLedgerEntryIds: string[] = []): Promise<{ linked: number }> => (await api.post("/Cash/link-collections", { financialAccountId, firmLedgerEntryIds, supplierLedgerEntryIds })).data,
  categories: async (source: CashTransactionSource): Promise<string[]> => (await api.get<string[]>("/Cash/categories", { params: { source } })).data,
  employees: async (): Promise<OptionItem[]> => (await api.get<OptionItem[]>("/Cash/employees")).data,
};

// Mizan ve nakit akış — finans modülü
export const financeReportService = {
  trialBalance: async (from: string, to: string): Promise<TrialBalance> => (await api.get<TrialBalance>("/FinanceReports/trial-balance", { params: { from, to } })).data,
  cashFlow: async (weeks = 8): Promise<CashFlow> => (await api.get<CashFlow>("/FinanceReports/cash-flow", { params: { weeks } })).data,
  accountantPack: async (from: string, to: string): Promise<Blob> => (await api.get("/FinanceReports/accountant-pack", { params: { from, to }, responseType: "blob" })).data,
};

// Çek ve Senet portföyü — finans modülü
export const chequeService = {
  overview: async (): Promise<ChequeOverview> => (await api.get<ChequeOverview>("/Cheques/overview")).data,
  list: async (q: ChequeQuery): Promise<Cheque[]> => (await api.get<Cheque[]>("/Cheques", { params: q })).data,
  get: async (id: string): Promise<Cheque> => (await api.get<Cheque>(`/Cheques/${id}`)).data,
  create: async (dto: ChequeUpsert): Promise<{ chequeId: string }> => (await api.post("/Cheques", dto)).data,
  update: async (id: string, dto: ChequeUpsert): Promise<void> => { await api.put(`/Cheques/${id}`, dto); },
  remove: async (id: string): Promise<void> => { await api.delete(`/Cheques/${id}`); },
  act: async (id: string, action: "deposit" | "undo-deposit" | "endorse" | "collect" | "bounce" | "return", dto: ChequeAction = {}): Promise<void> => { await api.post(`/Cheques/${id}/${action}`, dto); },
};

// Tedarikçi Carisi (Borçlar) — finans modülü
export const payablesService = {
  overview: async (): Promise<PayablesOverview> => (await api.get<PayablesOverview>("/Payables/overview")).data,
  statement: async (supplierId: string): Promise<SupplierStatement> => (await api.get<SupplierStatement>(`/Payables/supplier/${supplierId}`)).data,
  create: async (dto: SupplierLedgerUpsert): Promise<{ supplierLedgerEntryId: string }> => (await api.post("/Payables/entries", dto)).data,
  update: async (id: string, dto: SupplierLedgerUpsert): Promise<void> => { await api.put(`/Payables/entries/${id}`, dto); },
  remove: async (id: string): Promise<void> => { await api.delete(`/Payables/entries/${id}`); },
  syncReceipts: async (): Promise<{ added: number }> => (await api.post("/Payables/sync-receipts")).data,
};

// Cari Hesap ve Tahsilat — lisanslı modül; modül yoksa 403 MODULE_DISABLED
export const receivablesService = {
  overview: async (): Promise<ReceivablesOverview> => {
    const r = await api.get<ReceivablesOverview>("/Receivables/overview");
    return r.data;
  },
  statement: async (firmId: string): Promise<FirmStatement> => {
    const r = await api.get<FirmStatement>(`/Receivables/firm/${firmId}`);
    return r.data;
  },
  create: async (dto: LedgerEntryUpsert): Promise<{ firmLedgerEntryId: string }> => {
    const r = await api.post("/Receivables/entries", dto);
    return r.data;
  },
  update: async (id: string, dto: LedgerEntryUpsert): Promise<void> => {
    await api.put(`/Receivables/entries/${id}`, dto);
  },
  remove: async (id: string): Promise<void> => {
    await api.delete(`/Receivables/entries/${id}`);
  },
  syncInvoices: async (): Promise<{ added: number }> => {
    const r = await api.post("/Receivables/sync-invoices");
    return r.data;
  },
};

// Satın Alma — lisanslı modül; modül yoksa 403 MODULE_DISABLED
// İnsan Kaynakları — Faz 1: personel kartları, departman, pozisyon
export const hrService = {
  summary: async (): Promise<HrSummary> => (await api.get<HrSummary>("/Hr/summary")).data,
  employees: async (includeInactive = false): Promise<Employee[]> =>
    (await api.get<Employee[]>("/Hr/employees", { params: { includeInactive } })).data,
  employee: async (id: string): Promise<Employee> => (await api.get<Employee>(`/Hr/employees/${id}`)).data,
  // Kart = kullanıcı: oluşturunca hesap da açılır (login: geçici şifre; linkedExisting: kartsız eski hesaba bağlandı)
  createEmployee: async (dto: EmployeeUpsert): Promise<{ employeeId: string; employeeNumber: string; login?: EmployeeLoginResult | null; linkedExisting?: boolean }> =>
    (await api.post("/Hr/employees", dto)).data,
  // Hesabı olmayan eski kart kaydedilince hesap açılır → login döner
  updateEmployee: async (id: string, dto: EmployeeUpsert): Promise<{ login?: EmployeeLoginResult | null }> => (await api.put(`/Hr/employees/${id}`, dto)).data || {},
  resetLogin: async (id: string): Promise<EmployeeLoginResult> => (await api.post(`/Hr/employees/${id}/login/reset-password`)).data,
  setLoginActive: async (id: string, active: boolean): Promise<void> => { await api.post(`/Hr/employees/${id}/login/active`, { active }); },
  terminate: async (id: string, date: string, reason?: string, handoff?: { transferToEmployeeId: string | null; clearManager: boolean }): Promise<{ transferred: number } | undefined> =>
    (await api.post(`/Hr/employees/${id}/terminate`, { date, reason, ...(handoff || {}) })).data,
  reactivate: async (id: string): Promise<void> => { await api.post(`/Hr/employees/${id}/reactivate`); },
  deleteEmployee: async (id: string): Promise<void> => { await api.delete(`/Hr/employees/${id}`); },

  departments: async (includeInactive = false): Promise<HrNamedItem[]> =>
    (await api.get<HrNamedItem[]>("/Hr/departments", { params: { includeInactive } })).data,
  createDepartment: async (dto: { name: string; description?: string; sortOrder?: number }) => (await api.post("/Hr/departments", dto)).data,
  updateDepartment: async (id: string, dto: { name: string; description?: string; sortOrder?: number; isActive?: boolean }): Promise<void> => { await api.put(`/Hr/departments/${id}`, dto); },
  deleteDepartment: async (id: string): Promise<{ deleted: boolean; message: string }> => (await api.delete(`/Hr/departments/${id}`)).data,

  positions: async (includeInactive = false): Promise<HrPositionItem[]> =>
    (await api.get<HrPositionItem[]>("/Hr/positions", { params: { includeInactive } })).data,

  // ---- Faz 2: izin ----
  leaveTypes: async (includeInactive = false): Promise<LeaveType[]> => (await api.get<LeaveType[]>("/Hr/leave-types", { params: { includeInactive } })).data,
  createLeaveType: async (dto: LeaveTypeUpsert) => (await api.post("/Hr/leave-types", dto)).data,
  updateLeaveType: async (id: string, dto: LeaveTypeUpsert): Promise<void> => { await api.put(`/Hr/leave-types/${id}`, dto); },
  deleteLeaveType: async (id: string): Promise<{ deleted: boolean; message: string }> => (await api.delete(`/Hr/leave-types/${id}`)).data,
  seedLeaveTypes: async (): Promise<{ added: number }> => (await api.post("/Hr/leave-types/seed-defaults")).data,
  holidays: async (year?: number): Promise<PublicHoliday[]> => (await api.get<PublicHoliday[]>("/Hr/holidays", { params: { year } })).data,
  createHoliday: async (dto: { date: string; name: string; isHalfDay: boolean }) => (await api.post("/Hr/holidays", dto)).data,
  deleteHoliday: async (id: string): Promise<void> => { await api.delete(`/Hr/holidays/${id}`); },
  seedHolidays: async (year: number): Promise<{ added: number; religiousKnown: boolean }> => (await api.post(`/Hr/holidays/seed/${year}`)).data,
  balance: async (employeeId: string): Promise<LeaveBalance> => (await api.get<LeaveBalance>(`/Hr/leaves/balance/${employeeId}`)).data,
  leavePreview: async (p: { employeeId: string; leaveTypeId: string; start: string; end: string; startHalf: boolean; endHalf: boolean }): Promise<LeavePreview> =>
    (await api.get<LeavePreview>("/Hr/leaves/preview", { params: p })).data,
  leaves: async (params?: { status?: LeaveStatus; employeeId?: string; year?: number }): Promise<LeaveRequestRow[]> =>
    (await api.get<LeaveRequestRow[]>("/Hr/leaves", { params })).data,
  pendingLeaveCount: async (): Promise<{ count: number }> => (await api.get("/Hr/leaves/pending-count")).data,
  createLeave: async (dto: LeaveRequestCreate): Promise<{ leaveRequestId: string; status: LeaveStatus; workDays: number }> => (await api.post("/Hr/leaves", dto)).data,
  decideLeave: async (id: string, approve: boolean, note?: string): Promise<void> => { await api.post(`/Hr/leaves/${id}/decide`, { approve, note }); },
  cancelLeave: async (id: string, note?: string): Promise<void> => { await api.post(`/Hr/leaves/${id}/cancel`, { approve: false, note }); },

  // ---- Faz 2: dosyalar ----
  documents: async (employeeId: string): Promise<EmployeeDocumentRow[]> => (await api.get<EmployeeDocumentRow[]>(`/Hr/employees/${employeeId}/documents`)).data,
  uploadDocument: async (employeeId: string, file: File, category: number, description?: string, validUntil?: string, onProgress?: (pct: number) => void): Promise<{ employeeDocumentId: string; fileName: string; size: number }> => {
    const fd = new FormData(); fd.append("file", file); fd.append("category", String(category));
    if (description) fd.append("description", description); if (validUntil) fd.append("validUntil", validUntil);
    return (await api.post(`/Hr/employees/${employeeId}/documents`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: onProgress ? (ev) => onProgress(ev.total ? Math.round((ev.loaded / ev.total) * 100) : 0) : undefined,
    })).data;
  },
  updateDocument: async (id: string, dto: { category: number; description?: string; validUntil?: string | null }): Promise<void> => { await api.put(`/Hr/documents/${id}`, dto); },
  deleteDocument: async (id: string): Promise<void> => { await api.delete(`/Hr/documents/${id}`); },
  documentTypes: async (includeInactive = false): Promise<HrDocumentType[]> => (await api.get<HrDocumentType[]>("/Hr/documents/catalog", { params: { includeInactive } })).data,
  createDocumentType: async (dto: HrDocumentTypeUpsert): Promise<HrDocumentType> => (await api.post("/Hr/document-types", dto)).data,
  updateDocumentType: async (id: number, dto: HrDocumentTypeUpsert): Promise<HrDocumentType> => (await api.put(`/Hr/document-types/${id}`, dto)).data,
  deleteDocumentType: async (id: number): Promise<{ deleted: boolean; message: string }> => (await api.delete(`/Hr/document-types/${id}`)).data,
  documentChecklist: async (employeeId: string): Promise<DocChecklist> => (await api.get<DocChecklist>(`/Hr/employees/${employeeId}/documents/checklist`)).data,
  documentCompliance: async (departmentId?: string): Promise<DocCompliance> => (await api.get<DocCompliance>("/Hr/documents/compliance", { params: { departmentId: departmentId || undefined } })).data,
  documentComplianceExport: async (departmentId?: string): Promise<void> => {
    const r = await api.get("/Hr/documents/compliance/export", { params: { departmentId: departmentId || undefined }, responseType: "blob" });
    const url = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = url; a.download = `ozluk-eksikleri-${todayLocal()}.xlsx`; a.click(); setTimeout(() => URL.revokeObjectURL(url), 60000);
  },
  /** JWT taşıyan indirme: blob ile alınıp yeni sekmede/indirmede açılır. */
  openDocument: async (id: string, inline = true): Promise<void> => {
    const r = await api.get(`/Hr/documents/${id}/download`, { params: { inline }, responseType: "blob" });
    const url = URL.createObjectURL(r.data); window.open(url, "_blank"); setTimeout(() => URL.revokeObjectURL(url), 60000);
  },

  // ---- Faz 3: giriş-çıkış ----
  attendanceMe: async (): Promise<MyAttendance> => (await api.get<MyAttendance>("/Hr/attendance/me")).data,
  punch: async (kind?: PunchKind, note?: string): Promise<{ attendancePunchId: string; kind: PunchKind; punchedAt: string }> => (await api.post("/Hr/attendance/punch", { kind, note })).data,
  daily: async (date?: string, employeeId?: string): Promise<DailyBoard> => (await api.get<DailyBoard>("/Hr/attendance/daily", { params: { date, employeeId } })).data,
  attendanceHistory: async (employeeId: string, year?: number, month?: number): Promise<{ days: DaySummaryRow[]; punches: PunchRow[]; summary: MonthSummaryRow }> =>
    (await api.get(`/Hr/attendance/employee/${employeeId}`, { params: { year, month } })).data,
  timesheet: async (year: number, month: number): Promise<{ year: number; month: number; daysInMonth: number; rows: MonthSummaryRow[] }> =>
    (await api.get("/Hr/attendance/timesheet", { params: { year, month } })).data,
  timesheetExport: async (year: number, month: number): Promise<void> => {
    const r = await api.get("/Hr/attendance/timesheet/export", { params: { year, month }, responseType: "blob" });
    const url = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = url; a.download = `puantaj-${year}-${String(month).padStart(2, "0")}.xlsx`; a.click(); setTimeout(() => URL.revokeObjectURL(url), 60000);
  },
  manualPunch: async (dto: { employeeId: string; checkIn?: string | null; checkOut?: string | null; note: string }): Promise<void> => { await api.post("/Hr/attendance/manual", dto); },
  deletePunch: async (id: string): Promise<void> => { await api.delete(`/Hr/attendance/punch/${id}`); },
  importPunches: async (file: File): Promise<{ added: number; skipped: number; bad: number; unknown: string[]; unknownCount: number }> => {
    const fd = new FormData(); fd.append("file", file);
    return (await api.post("/Hr/attendance/import", fd, { headers: { "Content-Type": "multipart/form-data" } })).data;
  },
  shifts: async (includeInactive = false): Promise<ShiftRow[]> => (await api.get<ShiftRow[]>("/Hr/attendance/shifts", { params: { includeInactive } })).data,
  createShift: async (dto: { name: string; startTime: string; endTime: string; breakMinutes: number; workDays: string; color?: string }) => (await api.post("/Hr/attendance/shifts", dto)).data,
  updateShift: async (id: string, dto: { name: string; startTime: string; endTime: string; breakMinutes: number; workDays: string; color?: string; isActive?: boolean }): Promise<void> => { await api.put(`/Hr/attendance/shifts/${id}`, dto); },
  deleteShift: async (id: string): Promise<{ deleted: boolean; message: string }> => (await api.delete(`/Hr/attendance/shifts/${id}`)).data,
  attendanceConfig: async (): Promise<AttendanceConfig> => (await api.get<AttendanceConfig>("/Hr/attendance/settings")).data,
  updateAttendanceSettings: async (dto: AttendanceSettingsRow): Promise<void> => { await api.put("/Hr/attendance/settings", dto); },
  createDevice: async (dto: { name: string; kind: DeviceKind; location?: string }): Promise<{ attendanceDeviceId: string; key: string; kioskUrl?: string | null }> => (await api.post("/Hr/attendance/devices", dto)).data,
  rotateDeviceKey: async (id: string): Promise<{ key: string; kioskUrl?: string | null }> => (await api.post(`/Hr/attendance/devices/${id}/rotate-key`)).data,
  updateDevice: async (id: string, dto: { name: string; kind: DeviceKind; location?: string; isActive?: boolean }): Promise<void> => { await api.put(`/Hr/attendance/devices/${id}`, dto); },
  deleteDevice: async (id: string): Promise<void> => { await api.delete(`/Hr/attendance/devices/${id}`); },
  kioskIdentity: async (employeeId: string): Promise<KioskIdentity> => (await api.get<KioskIdentity>(`/Hr/attendance/employees/${employeeId}/kiosk`)).data,
  setKioskIdentity: async (employeeId: string, dto: { ensureQr?: boolean; regenerateQr?: boolean; pin?: string | null; deviceUserId?: string | null }): Promise<KioskIdentity> => (await api.post(`/Hr/attendance/employees/${employeeId}/kiosk`, dto)).data,

  // ---- Faz 4: self-servis, ekip, raporlar ----
  me: async (): Promise<HrMe> => (await api.get<HrMe>("/Hr/me")).data,
  team: async (date?: string): Promise<HrTeam> => (await api.get<HrTeam>("/Hr/team", { params: { date } })).data,
  leaveBalances: async (asOf?: string, departmentId?: string): Promise<LeaveBalanceReport> => (await api.get<LeaveBalanceReport>("/Hr/leaves/balances", { params: { asOf, departmentId: departmentId || undefined } })).data,
  leaveBalancesExport: async (asOf?: string, departmentId?: string): Promise<void> => {
    const r = await api.get("/Hr/leaves/balances/export", { params: { asOf, departmentId: departmentId || undefined }, responseType: "blob" });
    const url = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = url; a.download = `izin-bakiye-${asOf || todayLocal()}.xlsx`; a.click(); setTimeout(() => URL.revokeObjectURL(url), 60000);
  },
};

// Kiosk (oturumsuz): tablet cihaz anahtarıyla konuşur
export const kioskService = {
  info: async (key: string) => (await publicApi.get("/Hr/device/kiosk", { headers: { "X-Device-Key": key } })).data as { device: string; location?: string | null; pinAllowed: boolean; now: string },
  punch: async (key: string, body: { qrToken?: string; employeeNumber?: string; pin?: string; kind?: PunchKind }) =>
    (await publicApi.post("/Hr/device/kiosk/punch", body, { headers: { "X-Device-Key": key } })).data as { duplicate: boolean; name: string; kind?: PunchKind; at?: string; message?: string },
};

// Tedarikçiler — Stok modülü altında bağımsız yönetim (Satın Alma kapalıyken de çalışır)
export const supplierService = {
  list: async (includeInactive = false): Promise<SupplierRow[]> => (await api.get<SupplierRow[]>("/Supplier", { params: { includeInactive } })).data,
  get: async (id: string): Promise<SupplierDetail> => (await api.get<SupplierDetail>(`/Supplier/${id}`)).data,
  create: async (dto: SupplierUpsert): Promise<{ supplierId: string }> => (await api.post("/Supplier", dto)).data,
  update: async (id: string, dto: SupplierUpsert): Promise<void> => { await api.put(`/Supplier/${id}`, dto); },
  remove: async (id: string): Promise<{ deleted: boolean; message: string }> => (await api.delete(`/Supplier/${id}`)).data,
};

export const purchasingService = {
  suppliers: async (includeInactive = false): Promise<Supplier[]> =>
    (await api.get<Supplier[]>("/Purchasing/suppliers", { params: { includeInactive } })).data,
  createSupplier: async (dto: SupplierUpsert): Promise<{ supplierId: string }> =>
    (await api.post("/Purchasing/suppliers", dto)).data,
  updateSupplier: async (id: string, dto: SupplierUpsert): Promise<void> => {
    await api.put(`/Purchasing/suppliers/${id}`, dto);
  },
  deleteSupplier: async (id: string): Promise<{ deleted: boolean; message: string }> =>
    (await api.delete(`/Purchasing/suppliers/${id}`)).data,

  stats: async (): Promise<PurchasingStats> => (await api.get<PurchasingStats>("/Purchasing/stats")).data,
  orders: async (params?: { status?: PurchaseOrderStatus; supplierId?: string; search?: string }): Promise<PurchaseOrderListItem[]> =>
    (await api.get<PurchaseOrderListItem[]>("/Purchasing/orders", { params })).data,
  order: async (id: string): Promise<PurchaseOrderDetail> =>
    (await api.get<PurchaseOrderDetail>(`/Purchasing/orders/${id}`)).data,
  createOrder: async (dto: PurchaseOrderUpsert): Promise<{ purchaseOrderId: string; number: string }> =>
    (await api.post("/Purchasing/orders", dto)).data,
  updateOrder: async (id: string, dto: PurchaseOrderUpsert): Promise<void> => {
    await api.put(`/Purchasing/orders/${id}`, dto);
  },
  deleteOrder: async (id: string): Promise<void> => {
    await api.delete(`/Purchasing/orders/${id}`);
  },
  markOrdered: async (id: string): Promise<void> => {
    await api.post(`/Purchasing/orders/${id}/order`);
  },
  cancel: async (id: string, reason: string): Promise<void> => {
    await api.post(`/Purchasing/orders/${id}/cancel`, { reason });
  },
  receive: async (id: string, dto: ReceiveRequest): Promise<{ purchaseReceiptId: string; lines: number; stockMovements: number }> =>
    (await api.post(`/Purchasing/orders/${id}/receive`, dto)).data,
  priceHistory: async (stockId: string): Promise<StockPriceHistory[]> =>
    (await api.get<StockPriceHistory[]>(`/Purchasing/stocks/${stockId}/price-history`)).data,
};

// ============ Sevkiyat (shipping) ============
export const shippingService = {
  stats: async (): Promise<ShippingStats> => (await api.get<ShippingStats>("/Shipping/stats")).data,
  shipments: async (params?: { status?: ShipmentStatus; firmId?: string; search?: string; from?: string; to?: string }): Promise<ShipmentListItem[]> =>
    (await api.get<ShipmentListItem[]>("/Shipping/shipments", { params })).data,
  shipment: async (id: string): Promise<ShipmentDetail> => (await api.get<ShipmentDetail>(`/Shipping/shipments/${id}`)).data,
  create: async (dto: ShipmentUpsert): Promise<{ shipmentId: string; number: string }> => (await api.post("/Shipping/shipments", dto)).data,
  update: async (id: string, dto: ShipmentUpsert): Promise<void> => { await api.put(`/Shipping/shipments/${id}`, dto); },
  remove: async (id: string): Promise<void> => { await api.delete(`/Shipping/shipments/${id}`); },
  ship: async (id: string, dto: ShipRequest): Promise<{ shipmentId: string; number: string; status: ShipmentStatus; shippedAt: string; waybillNo?: string | null; stockMovements: number }> =>
    (await api.post(`/Shipping/shipments/${id}/ship`, dto)).data,
  deliver: async (id: string, dto: DeliverRequest): Promise<void> => { await api.post(`/Shipping/shipments/${id}/deliver`, dto); },
  cancel: async (id: string, reason: string): Promise<void> => { await api.post(`/Shipping/shipments/${id}/cancel`, { reason }); },
  shippableOrders: async (firmId: string, includeFullyShipped = false): Promise<ShippableOrder[]> =>
    (await api.get<ShippableOrder[]>("/Shipping/shippable-orders", { params: { firmId, includeFullyShipped } })).data,
  orderSummary: async (orderId: string): Promise<OrderShipmentSummary> => (await api.get<OrderShipmentSummary>(`/Shipping/orders/${orderId}`)).data,
  /** Yazdırma görünümü (HTML) — token taşıdığı için <a href> değil, metin olarak çekilir */
  printHtml: async (id: string): Promise<string> =>
    (await api.get(`/Shipping/shipments/${id}/print`, { responseType: "text", transformResponse: (r) => r })).data as string,
};

// ============ Bildirimler ============
export const notificationService = {
  list: async (unreadOnly = false, limit = 50): Promise<AppNotification[]> =>
    (await api.get<AppNotification[]>("/Notifications", { params: { unreadOnly, limit } })).data,
  unreadCount: async (): Promise<number> => (await api.get<{ count: number }>("/Notifications/unread-count")).data.count,
  markRead: async (id: string): Promise<void> => { await api.post(`/Notifications/${id}/read`); },
  markAllRead: async (): Promise<number> => (await api.post<{ marked: number }>("/Notifications/read-all")).data.marked,
  preferences: async (): Promise<NotificationPreference[]> => (await api.get<NotificationPreference[]>("/Notifications/preferences")).data,
  savePreferences: async (prefs: { type: NotificationType; inApp: boolean; email: boolean }[]): Promise<void> => { await api.put("/Notifications/preferences", prefs); },
  remove: async (id: string): Promise<void> => { await api.delete(`/Notifications/${id}`); },
  clearRead: async (): Promise<number> => (await api.delete<{ removed: number }>("/Notifications/read")).data.removed,
  scan: async (sendDigests = false): Promise<NotificationScanResult> => (await api.post<NotificationScanResult>(`/Notifications/scan?sendDigests=${sendDigests}`)).data,
};

// ==================== RANDEVU VE TAKVİM ====================

export const appointmentService = {
  types: async (): Promise<AppointmentType[]> =>
    (await api.get<AppointmentType[]>("/Appointments/types")).data,
  saveType: async (dto: AppointmentType): Promise<{ appointmentTypeId: string }> =>
    (await api.post("/Appointments/types", dto)).data,
  removeType: async (id: string): Promise<void> => {
    await api.delete(`/Appointments/types/${id}`);
  },

  profile: async (userId?: string): Promise<StaffBookingProfile> =>
    (await api.get<StaffBookingProfile>("/Appointments/profile", { params: { userId } })).data,
  saveProfile: async (dto: StaffBookingProfile): Promise<{ slug: string; publicUrl: string }> =>
    (await api.put("/Appointments/profile", dto)).data,

  availability: async (userId?: string): Promise<StaffAvailabilityRow[]> =>
    (await api.get<StaffAvailabilityRow[]>("/Appointments/availability", { params: { userId } })).data,
  saveAvailability: async (rows: StaffAvailabilityRow[], userId?: string): Promise<void> => {
    await api.put("/Appointments/availability", rows, { params: { userId } });
  },

  exceptions: async (userId?: string, from?: string, to?: string): Promise<AvailabilityExceptionRow[]> =>
    (await api.get<AvailabilityExceptionRow[]>("/Appointments/exceptions", { params: { userId, from, to } })).data,
  saveException: async (dto: AvailabilityExceptionRow, userId?: string): Promise<{ availabilityExceptionId: string }> =>
    (await api.post("/Appointments/exceptions", dto, { params: { userId } })).data,
  removeException: async (id: string): Promise<void> => {
    await api.delete(`/Appointments/exceptions/${id}`);
  },

  saveBlock: async (dto: CalendarBlock): Promise<{ calendarBlockId: string }> =>
    (await api.post("/Appointments/blocks", dto)).data,
  removeBlock: async (id: string): Promise<void> => {
    await api.delete(`/Appointments/blocks/${id}`);
  },

  calendar: async (from: string, to: string, userId?: string, scope?: "team"): Promise<AppointmentCalendar> =>
    (await api.get<AppointmentCalendar>("/Appointments/calendar", { params: { from, to, userId, scope } })).data,
  people: async (): Promise<AppointmentPeople> => (await api.get<AppointmentPeople>("/Appointments/people")).data,
  pending: async (): Promise<Appointment[]> =>
    (await api.get<Appointment[]>("/Appointments/pending")).data,
  get: async (id: string): Promise<Appointment> =>
    (await api.get<Appointment>(`/Appointments/${id}`)).data,
  approve: async (id: string): Promise<void> => {
    await api.post(`/Appointments/${id}/approve`, {});
  },
  reject: async (id: string, reason?: string): Promise<void> => {
    await api.post(`/Appointments/${id}/reject`, { reason });
  },
  setStatus: async (id: string, status: AppointmentStatus, reason?: string): Promise<void> => {
    await api.post(`/Appointments/${id}/status`, { status, reason });
  },
  slots: async (userId: string, typeId: string, from: string, to: string): Promise<BookingSlotDay[]> =>
    (await api.get<BookingSlotDay[]>("/Appointments/slots", { params: { userId, typeId, from, to } })).data,
};

/**
 * Girişsiz randevu uçları. Oturum taşımayan ayrı istemciyi kullanır:
 * bu sayfaları açan kişinin sistemde hesabı yoktur.
 */
export const publicBookingService = {
  staff: async (): Promise<PublicStaff[]> =>
    (await publicApi.get<PublicStaff[]>("/public/booking/staff")).data,
  page: async (slug: string): Promise<BookingPage> =>
    (await publicApi.get<BookingPage>(`/public/booking/${slug}`)).data,
  slots: async (slug: string, typeId: string, from: string, to: string): Promise<BookingSlotDay[]> =>
    (await publicApi.get<BookingSlotDay[]>(`/public/booking/${slug}/slots`, { params: { typeId, from, to } })).data,
  book: async (slug: string, dto: BookingRequest): Promise<{ number: string; message: string }> =>
    (await publicApi.post(`/public/booking/${slug}`, dto)).data,
  verify: async (token: string): Promise<{ token: string; message: string }> =>
    (await publicApi.post(`/public/booking/verify/${token}`, {})).data,
  mine: async (token: string): Promise<GuestAppointment> =>
    (await publicApi.get<GuestAppointment>(`/public/booking/appointment/${token}`)).data,
  cancel: async (token: string, reason?: string): Promise<{ message: string }> =>
    (await publicApi.post(`/public/booking/appointment/${token}/cancel`, { reason })).data,
};

/** Google Takvim bağlantısı (randevu modülü). */
export const googleCalendarService = {
  status: async (): Promise<GoogleAccountStatus> =>
    (await api.get<GoogleAccountStatus>("/Appointments/google/status")).data,
  connectUrl: async (): Promise<string> =>
    (await api.post<{ url: string }>("/Appointments/google/connect", {})).data.url,
  disconnect: async (): Promise<void> => {
    await api.delete("/Appointments/google/disconnect");
  },
};

// Denetim izi — salt okunur (yazma ucu yok). Tarihler TR yerel "YYYY-MM-DD".
export const auditService = {
  list: async (q: AuditQuery): Promise<AuditPage> => (await api.get<AuditPage>("/AuditTrail", { params: q })).data,
  get: async (id: number): Promise<AuditDetail> => (await api.get<AuditDetail>(`/AuditTrail/${id}`)).data,
  entity: async (type: string, id: string, children = true): Promise<AuditDetail[]> =>
    (await api.get<AuditDetail[]>(`/AuditTrail/entity/${encodeURIComponent(type)}/${encodeURIComponent(id)}`, { params: { children } })).data,
  correlation: async (cid: string): Promise<AuditDetail[]> => (await api.get<AuditDetail[]>(`/AuditTrail/correlation/${encodeURIComponent(cid)}`)).data,
  stats: async (from?: string, to?: string): Promise<AuditStats> => (await api.get<AuditStats>("/AuditTrail/stats", { params: { from, to } })).data,
  meta: async (): Promise<AuditMeta> => (await api.get<AuditMeta>("/AuditTrail/meta")).data,
  exportExcel: async (q: AuditQuery): Promise<Blob> => (await api.get("/AuditTrail/export", { params: q, responseType: "blob" })).data,
};
